export const CALL_API = Symbol('CALL_API')

const resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503]

function getAction(type, action, state, res) {
    return new Promise((resolve, reject) => {
        if (!res) return resolve({ type })
        if (resStatusError.includes(res.status)) {
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList })
        }

        if (typeof type === 'object') {
            if (type.payload) {
                const payload = type.payload(action, state, res)
                if (typeof payload.then === 'function') { //promise
                    return payload.then(data => resolve({ type: type.type, payload: data }))
                } else {
                    return resolve({ type: type.type, payload })
                }
            }

            return resolve({ type: type.type })
        }

        res.json().then(payload => resolve({ type, payload }))
    })
}

export default ({ getState }) => next => action => {
    if (typeof action[CALL_API] !== 'object') return next(action)

    const {
        endpoint,
        method = 'GET',
        headers,
        body,
        types
    } = action[CALL_API]

    const [request, success, failure] = types
    const { callBack } = success
    const state = getState()
    getAction(request, action, state).then(action => next(action))

    if (callBack) {
        let url = { endpoint: endpoint, method: method }
        fetch(endpoint, { method, headers, body })
            .then(res => getAction(success, action, state, res))
            .then(action => next(action))
            .then(() => callBack())
            .catch(err => next({ type: failure, payload: err, error: true, url: url }))
    } else {
        fetch(endpoint, { method, headers, body })
            .then(res => getAction(success, action, state, res))
            .then(action => next(action))
            .catch(err => next({ type: failure, payload: err, error: true }))
    }
}


// WEBPACK FOOTER //
// ./src/middlewares/api.js